import { render } from "./pl3wei.vue?vue&type=template&id=eeb27ed2&scoped=true"
import script from "./pl3wei.vue?vue&type=script&lang=js"
export * from "./pl3wei.vue?vue&type=script&lang=js"

import "./pl3wei.vue?vue&type=style&index=0&id=eeb27ed2&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb27ed2"]])

export default __exports__